import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "wrapper"]
  static outlets = ["invoice"]

  applyDepartmentDefault(deptAttributes) {
    this.currentDeptAttributes = deptAttributes
    if (!this.invoiceOutlet.incomeValue) return

    const show = deptAttributes["lump_sum_taxed"] === true
    this.wrapperTargets.forEach((wrapper) => wrapper.classList.toggle("hidden", !show))
    this.fieldTargets.forEach((field) => { field.disabled = !show })
    if (!show) return

    this.invoiceOutlet.invoicePositionCalculatorOutlets.forEach((position) => {
      if (!position.hasLumpSumTaxFieldTarget || !position.isEmpty()) return
      position.lumpSumTaxFieldTarget.value = deptAttributes["default_lump_sum_tax"] || ""
    })
  }

  wrapperTargetConnected(wrapper) {
    if (!this.currentDeptAttributes) return
    wrapper.classList.toggle("hidden", this.currentDeptAttributes["lump_sum_taxed"] !== true)
  }

  fieldTargetConnected(field) {
    if (!this.currentDeptAttributes) return
    const show = this.currentDeptAttributes["lump_sum_taxed"] === true
    field.disabled = !show
    if (show) field.value = this.currentDeptAttributes["default_lump_sum_tax"] || ""
  }
}
